'use strict';

import React from 'react';
import {browserHistory} from 'react-router';
import API from 'sources/API';
import BusinessActions from 'actions/BusinessActions';
import BusinessStore from 'stores/BusinessStore';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';

import Progress from 'antd/lib/progress';
import 'antd/lib/progress/style/css';

require('styles/NewBusiness.scss');
let $ = window.$
class NewBusinessComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      desc: '',
      localImage: {},
      image: '',
      upProgress: 0,
      localAdImage: {},
      imageAd: '',
      adUpProgress: 0
    }
    this.handleTextChange = this.handleTextChange.bind(this)
    this.onClear = this.onClear.bind(this)
    this.onGoBack = this.onGoBack.bind(this)
    this.toggleErrorMsgReveal =  this.toggleErrorMsgReveal.bind(this)
    this.picUpload = this.picUpload.bind(this)
    this.picUploadAd = this.picUploadAd.bind(this)
    this.onSave = this.onSave.bind(this)
  }
  onSave() {
  	if(!this.state.name){
  	  this.setState({
        error: "商铺名称不可为空"
  	  });
  	  return;
    }
    if(!this.state.desc){
      this.setState({
        error: "商铺简介不可为空"
      });
      return;
    }
    if(!this.state.image){
      this.setState({
        error: "商铺头像不可为空"
      });
      return;
    }
    if(!this.state.imageAd){
      this.setState({
        error: "商铺二维码不可为空"
      });
      return;
    }
    BusinessActions.postBusiness({
      name: this.state.name,
      summary: this.state.desc,
      avatar: this.state.image,
      ad_url: this.state.imageAd
    });
  }
  picUpload(event) {
    let img = event.target.files[0];
    let reader = new FileReader();
    let that = this;
    reader.readAsDataURL(img);
    reader.onload = function(e) {
      that.setState((previousState)=>{
        previousState.localImage = {
          url: e.target.result,
          uploading: true
        };
        return {
          localImage: previousState.localImage
        };
      });
    }
    let formData = new FormData();
    formData.append('file', img);
    this.setState({upProgress:0});
    let progresses = [0,10,33,40,66,84,95];
    progresses.forEach((value,index) => {
      setTimeout(() => {
        if(that.state.localImage.uploading){
          that.setState({upProgress: value});
        }
      },250 * index)
    });
    fetch(`${API.imageUpload}`, {
      method: 'POST',
      body: formData
    }).then(res=>res.json())
    .then(json=>{
      if(json.status === 0) {
        this.setState((previousState)=>{
          previousState.image = json.url;
          previousState.localImage.uploading = false;
          return {
            image: previousState.image,
            localImage: previousState.localImage
          };
        });
      }
    });
  }
  picUploadAd(event) {
    let img = event.target.files[0];
    let reader = new FileReader();
    let that = this;
    reader.readAsDataURL(img);
    reader.onload = function(e) {
      that.setState((previousState)=>{
        previousState.localAdImage = {
          url: e.target.result,
          uploading: true
        };
        return {
          localAdImage: previousState.localAdImage
        };
      });
    }
    let formData = new FormData();
    formData.append('file', img);
    this.setState({adUpProgress:0});
    let progresses = [0,10,33,40,66,84,95];
    progresses.forEach((value,index) => {
      setTimeout(() => {
        if(that.state.localAdImage.uploading){
          that.setState({adUpProgress: value});
        }
      },150 * index)
    });
    fetch(`${API.imageUpload}`, {
      method: 'POST',
      body: formData
    }).then(res=>res.json())
    .then(json=>{
      if(json.status === 0) {
        this.setState((previousState)=>{
          previousState.imageAd = json.url;
          previousState.localAdImage.uploading = false;
          return {
            imageAd: previousState.imageAd,
            localAdImage: previousState.localAdImage
          };
        });
      }
    });
  }
  handleTextChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }
  toggleErrorMsgReveal() {
    this.setState({
     error: ""
   });
  }
  onGoBack() {
    browserHistory.goBack();
  }
  onClear() {
    this.setState({
      name: '',
      desc: '',
      localImage: {},
      image: '',
      localAdImage: {},
      imageAd: ''
    });
  }
  render(){
    let errorMsgReveal;
    if(this.state.error){
      errorMsgReveal=(
        <div className="text-center error-msg" >
          <button className="close-btn" onClick={this.toggleErrorMsgReveal} aria-label="Close alert" type="button">
            <span aria-hidden="true">×</span>
          </button>
          {this.state.error}
        </div>
      );	
    }
  	return (
  	  <div className="New-Business-component">
        <div className="row align-center header">
          <a className="columns text-white text-left small-3 pl-15" onClick={this.onGoBack}>返回</a>
          <span className="title columns small-6 text-center">
            新建商铺
          </span>
          <a className='pr-15 columns small-3 text-white text-right' onClick={this.onClear}>重置</a>
        </div>
        <div className="form mt-30">
          <div className="columns mb-20">
            <div className="left col">
              <div className="fz-10 text-gray mb-10 attention">商铺头像</div>
              {(!this.state.image&&!this.state.localImage.url)?(
                <div className="add-pic">
                  <input type="file" onChange={this.picUpload} className="pic-input" multiple="multiple" name="pic" />
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
              ):(
                this.state.localImage.url?(
                  this.state.localImage.uploading?(
                    <div className="add-pic">
                      <div className="progress"><Progress type="circle" percent={this.state.upProgress} width={40}/></div>
                    </div>
                  ):(
                    <div className="avatar"> 
                      <img onClick={()=>{document.getElementById('img-upload').click()}} style={{backgroundImage:`url(${this.state.localImage.url})`,backgroundPosition:'center'}}/>
                      <input id="img-upload" type="file" onChange={this.picUpload} className="pic-input" multiple="multiple" name="pic" />
                    </div>
                  )
                ):(
                  <div className="avatar"> 
                    <img src={this.state.image} />
                  </div>
                )
              )}
            </div>
            <div className="right col">
              <div className="fz-10 text-gray mb-10 attention">商铺二维码 (推荐300x300px)</div>
              {!this.state.imageAd&&!this.state.localAdImage.url?(
                <div className="add-pic">
                  <input type="file" onChange={this.picUploadAd} className="pic-input" multiple="multiple" name="pic" />
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
              ):(
                this.state.localAdImage.url?(
                  this.state.localAdImage.uploading?(
                    <div className="add-pic">
                      <div className="progress"><Progress type="circle" percent={this.state.adUpProgress} width={40}/></div>
                    </div>
                  ):(
                    <div className="avatar">
                      <img onClick={()=>{document.getElementById('ad-img-upload').click()}} style={{backgroundImage:`url(${this.state.localAdImage.url})`,backgroundPosition:'center'}}/>
                      <input id="ad-img-upload" type="file" onChange={this.picUploadAd} className="pic-input" multiple="multiple" name="pic" />
                    </div>
                  )
                ):(
                  <div className="avatar"> 
                    <img src={this.state.imageAd} />
                  </div>
                )
              )}
            </div>
            <div className="clear"></div>
          </div>
          <div className="columns">
            <input type="text" placeholder="商家名称" name='name' value={this.state.name} onChange={this.handleTextChange}/>
          </div>
          <div className="columns mb-15">
            <textarea className="desc height-100" name='desc' onChange={this.handleTextChange} placeholder="商家简介～～" value={this.state.desc}></textarea>
          </div>
          <div className="columns">
          {errorMsgReveal}
          </div>
          <div className="columns">
            <button className="button width-all" onClick={this.onSave}>保存</button>
          </div>
        </div>
  	  </div>
  	);
  }
}

NewBusinessComponent.displayName = 'NewBusinessComponent';

export default NewBusinessComponent;



// WEBPACK FOOTER //
// ./src/components/NewBusinessComponent.js